<template>
  <div class="coaching-container">
    <router-link
      :to="coachesPageRoute"
      class="coaching"
      :class="{
        active: $route.name === ROUTER_NAMES.COACHES,
      }"
    >
      <span class="name">COACHING</span>
      <span v-if="totalOnlineCoaches > 0" class="total">
        {{ totalOnlineCoaches }}
      </span>
    </router-link>
    <router-link
      v-if="!isUserPro"
      :to="{ name: ROUTER_NAMES.SUBSCRIPTION }"
      class="go-pro"
    >
      GO PRO NOW
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { ROUTER_NAMES } from "@/constants/router.constants"
import { GAME_KEYS } from "@/store/game/game.constants"

export default {
  computed: {
    ...mapGetters("User", ["isUserPro", "currentActiveGame"]),
    ...mapGetters("Games", ["getGames"]),
    coachesPageRoute () {
      const game = this.currentActiveGame ||
        this.$route.params.game ||
        GAME_KEYS.LEAGUE_OF_LEGENDS
      return {
        name: ROUTER_NAMES.COACHES,
        params: { game },
      }
    },
    totalOnlineCoaches () {
      let coaches = 0
      if (this.getGames) {
        Object.values(this.getGames).forEach(game => {
          coaches += game.resource_metadata.coaching.num_coaches_active
        })
      }
      return coaches
    },
  },
  created () {
    this.ROUTER_NAMES = ROUTER_NAMES
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";

.coaching-container {
  font-family: $font-display;
  font-weight: 700;
  margin: 0 2rem;
  display: flex;
  align-items: center;
  margin-left: 0;
  font-size: 1.5rem;
  line-height: 110%;
  @include desktop-down {
    flex-direction: column;
    margin: 0 4rem;
  }
  .go-pro {
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #e4b334 0, #f9d067 100%);
    border-radius: 4px;
    color: #18181b;
    font-size: 1.5rem;
    line-height: 110%;
    padding: 0 1.6rem;
    height: 3.5rem;
    transition: background 0.2s;
    margin-left: 1rem;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      background: linear-gradient(
        rgb(249, 208, 103) 0px,
        rgb(228, 179, 52) 100%
      );
    }
    @include desktop-down {
      display: none;
    }
  }
  .coaching {
    margin: 0 2rem;
    height: 5.5rem;
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    line-height: 110%;
    color: rgb(255, 255, 255);
    border-bottom: 2px solid transparent;
    cursor: pointer;

    @include desktop-down {
      justify-content: space-between;
      font-size: 1.9rem;
      width: 100%;
    }
    .name {
      opacity: 0.6;
    }
    .total {
      margin-left: 1rem;
      display: flex;
      align-items: center;
      @include desktop-down {
        color: rgba(255, 255, 255, 0.6);
      }
      &:before {
        background-color: #ff0431;
        border-radius: 50%;
        content: "";
        display: inline-block;
        margin-right: 0.5rem;
        width: 1rem;
        height: 1rem;
      }
    }
    &:hover,
    &.active {
      border-bottom: 2px solid #fff;
      @include desktop-down {
        border-color: transparent;
      }
      transition: border-color 0.2s linear;
      .name {
        opacity: 1 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/CoachingContainer.vue